import { render, staticRenderFns } from "./RecurringProjectSettings.vue?vue&type=template&id=0efe67de&"
import script from "./RecurringProjectSettings.vue?vue&type=script&lang=js&"
export * from "./RecurringProjectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports